module.exports = __webpack_public_path__ + "static/4-eedb5aad9896b20f0cddf5c280dcbac2.svg";